import BaseResource from './BaseResource';

export default class QuoteSetResource extends BaseResource {
  constructor() {
    super({ url: '/api' });
  }

  create(data, propertyId) {
    return super
      .post(data, { url: `${this.url}/properties/${propertyId}/quote_sets` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  get(id) {
    return super
      .get({ url: `${this.url}/quote_sets/${id}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  delete(id) {
    return super
      .delete({ url: `${this.url}/quote_sets/${id}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  update(id, name) {
    return super
      .patch({ name }, { url: `${this.url}/quote_sets/${id}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  getProperty(id) {
    return super
      .get({ url: `${this.url}/quote_sets/${id}/property` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
